import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { Field } from 'formik';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';

function toCurrencyFormat(controlToCheck) {
  var enteredNumber = '' + controlToCheck.target.value;
  enteredNumber = enteredNumber.replace(/[^0-9\.]+/g, '');
  controlToCheck.target.value = Number(enteredNumber).toLocaleString('en-US', {
    style: 'currency',
    currency: 'INR',
  });
}

export const PastIncrementsForm = ({ handleChange, values, errors, touched }) => (
  <div className="signite-form">
    <Row className="mb-3">
      <BSForm.Group as={Col} controlId="firstYearIncrement">
        <BSForm.Label>Current Year 1st Increment %</BSForm.Label>
        <BSForm.Control
          type="text"
          value={values.firstYearIncrement}
          name={`firstYearIncrement`}
          onChange={handleChange}
          className={`form-control ${getErrorClass(errors, touched, 'firstYearIncrement')}`}
        />
        <span className="errorMessage">{getErrorMessage(errors, touched, 'firstYearIncrement')}</span>
      </BSForm.Group>
      <BSForm.Group as={Col} controlId="secondYearIncrement">
        <BSForm.Label>Current Year 2nd Increment %</BSForm.Label>
        <BSForm.Control
          type="text"
          value={values.secondYearIncrement}
          name={`secondYearIncrement`}
          onChange={handleChange}
          className={`form-control ${getErrorClass(errors, touched, 'secondYearIncrement')}`}
        />
        <span className="errorMessage">{getErrorMessage(errors, touched, 'secondYearIncrement')}</span>
      </BSForm.Group>
      <BSForm.Group as={Col} controlId="expectedCTC">
        <BSForm.Label>Expected CTC</BSForm.Label>
        <BSForm.Control
          type="text"
          value={values.expectedCTC}
          name={`expectedCTC`}
          onChange={handleChange}
          className={`form-control ${getErrorClass(errors, touched, 'expectedCTC')}`}
        />
        <span className="errorMessage">{getErrorMessage(errors, touched, 'expectedCTC')}</span>
      </BSForm.Group>
    </Row>
    <Row className="mb-3">
      <BSForm.Group as={Col} controlId="fixedCtcExpectation">
        <BSForm.Label>Fixed CTC Expectation</BSForm.Label>
        <BSForm.Control
          type="text"
          name={`fixedCtcExpectation`}
          value={values.fixedCtcExpectation}
          onChange={handleChange}
          className={`form-control ${getErrorClass(errors, touched, 'fixedCtcExpectation')}`}
        />
        <span className="errorMessage">{getErrorMessage(errors, touched, 'fixedCtcExpectation')}</span>
      </BSForm.Group>
      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
    </Row>
  </div>
);
